const openedPaymentPage = {
  fawry: {
    title: 'Ödemeniz oluşturuldu!',
    importantMessage: {
      title: 'Bilmeniz gerekenler',
      description: 'Ödemenizi tamamlamak ve iptal edilmesini önlemek için lütfen referans kodunu kullanarak belirtilen süre içinde herhangi bir Fawry kanalı, şubesi veya Fawry Uygulaması üzerinden ödeme yapın',
    },
    orderDetail: {
      expirationDate: 'Ödeme son tarihi:',
      totalAmount: 'Toplam tutar',
    },
    referenceNumber: {
      title: 'Referans numarası',
      copy: 'Kopyala',
      copied: 'Kopyalandı!',
    },
  },
  customer: {
    form: {
      fieldCustomerBirthdate: {
        label: 'Doğum Tarihi',
        validationMessage: {
          empty: 'Lütfen doğum tarihinizi girin',
          invalid: 'Geçersiz doğum tarihi',
          serverError: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
        },
      },
    },
  },
  cryptocurrency: {
    disclaimer1: 'Kripto para ile yapılan ödemeler yalnızca yetkili harici sağlayıcılar tarafından işlenir, EBANX tarafından değil. Sağlayıcıların detayları, ilgili lisansları ve düzenleyici durumları dahil olmak üzere, geçerli ',
    termsAndConditions: 'Şartlar ve Koşullar',
    disclaimer2: '\'da belirtilmiştir.',
    merchantInfo: {
      returnButton: 'Bu ödemeyi iptal edebilir ve başka bir ödeme yöntemi seçmek için ödeme sayfasına dönebilirsiniz.',
      backTo: 'İptal et ve geri dön',
    },
  },
};

module.exports = openedPaymentPage;
